import { Schema } from 'hubspot-prosemirror/pm/model';

export const suggestionTypes = {
  atMention: 'AT_MENTION',
  tag: 'TAG_MENTION',
  emoji: 'EMOJI',
  slashAI: 'AI_SLASH',
} as const;

export const AT_MENTION = suggestionTypes.atMention;
export const TAG_MENTION = suggestionTypes.tag;
export const AI_SLASH = suggestionTypes.slashAI;

export type SuggestionType =
  (typeof suggestionTypes)[keyof typeof suggestionTypes];

export function getMentionTrigger(suggestionType: SuggestionType) {
  switch (suggestionType) {
    case 'AT_MENTION':
      return '@';
    case 'TAG_MENTION':
      return '#';
    case 'EMOJI':
      return ':';
    case 'AI_SLASH':
      return '/';
    default:
      return '@';
  }
}

export function getMentionNodeType(
  schema: Schema,
  suggestionType: SuggestionType
) {
  switch (suggestionType) {
    case 'AT_MENTION':
      return schema.nodes.atmention;
    case 'TAG_MENTION':
      return schema.nodes.tag;
    default:
      return schema.nodes.atmention;
  }
}
